(function () {
  function initBlog(root) {
    if (!root || root.dataset.wlBlogReady === 'true') return;
    root.dataset.wlBlogReady = 'true';

    const grid = root.querySelector('[data-wl-blog-grid]');
    const quick = root.querySelector('[data-wl-blog-quick]');
    const quickItems = quick ? Array.from(quick.querySelectorAll('[data-wl-blog-card]')) : [];
    const quickEmpty = quick ? quick.querySelector('[data-wl-quick-empty]') : null;
    const quickCount = quick ? quick.querySelector('[data-wl-quick-count]') : null;
    const sideCards = grid ? Array.from(grid.querySelectorAll('.wl-blog-card--side[data-wl-blog-card]')) : [];
    const pills = Array.from(root.querySelectorAll('[data-wl-cat]'));
    const viewAll = root.querySelector('[data-wl-cat-all]');

    function setActivePill(category) {
      pills.forEach((pill) => {
        const active = pill.dataset.wlCat === category;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function filterCategory(category) {
      const isAll = category === 'All';

      sideCards.forEach((card) => {
        const match = isAll || card.dataset.category === category;
        card.classList.toggle('is-filtered-out', !match);
      });

      let visibleQuick = 0;
      quickItems.forEach((item) => {
        const match = isAll || item.dataset.category === category;
        item.classList.toggle('is-hidden', !match);
        if (match) visibleQuick += 1;
      });

      if (quick) {
        quick.classList.toggle('is-filtered-out', !isAll && visibleQuick === 0);
      }

      if (quickEmpty) {
        quickEmpty.hidden = isAll || visibleQuick > 0;
      }

      if (quickCount) {
        quickCount.textContent = isAll
          ? `${quickItems.length} articles`
          : `${visibleQuick} article${visibleQuick === 1 ? '' : 's'}`;
      }

      setActivePill(category);
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', () => filterCategory(pill.dataset.wlCat || 'All'));
    });

    if (viewAll) {
      viewAll.addEventListener('click', () => filterCategory('All'));
    }
  }

  document.querySelectorAll('[data-wl-blog]').forEach(initBlog);
})();
